<div class="form-item" [ngClass]="'form-field-'+field.type">
  <div class="form-field-menu">
    <core-helpers-navigation-three-dots-menu [menu]="fieldMenu"
      (action)="onMenuClick($event)"></core-helpers-navigation-three-dots-menu>
  </div>
  <div [ngClass]="{'invalid-field': field.label == ''}">
    <input type="text" [ngModel]="field.label" [placeholder]="placeholder" (ngModelChange)="onFieldChange($event)">
  </div>

  <div  [ngClass]="{'invalid-field': !field.ready}">
    <div>
      <label>URL to open</label>
    </div>
    <!-- Make this placholder dinamicaly-->
    <input type="text" [ngModel]="field.url" (ngModelChange)="onUrlChange($event)"
      placeholder="https://url.to.open?projecturlparam={PROJECTID}&formurlparam={FORMID}">
      
  </div>
<div class="fieldset fieldset-bottom">
  <core-helpers-forms-button [text]="'Add Project ID'" (submit)="addProjectId()" [disabled]="isProjectIdAdded">
  </core-helpers-forms-button>

  <core-helpers-forms-button [text]="'Add Form ID'" (submit)="addFormId()" [disabled]="isFormIdAdded">
  </core-helpers-forms-button>
</div>
  <div class="field-mandatory">
    <core-helpers-forms-input-checkbox [label]="'Button avaliable on view'" [form]="form" [defaultChecked]="field.mandatory"
      (checkedChange)="onAvailableOnViewChange($event)"></core-helpers-forms-input-checkbox>
  </div>

</div>